import React from "react";
import { useTilt } from "../hooks/useTilt";

/**
 * Wrapper that applies 3D mouse-tracking tilt + a dynamic cursor-following glare overlay.
 */
export const TiltCard = ({
  as: Tag = "article",
  className = "",
  children,
  max = 7,
  glare = true,
  ...rest
}) => {
  const ref = useTilt(max);
  return (
    <Tag
      ref={ref}
      className={`tilt-card ${className}`}
      style={{ transformStyle: "preserve-3d" }}
      {...rest}
    >
      <div className="tilt-content">{children}</div>
      {glare && <span className="tilt-glare" aria-hidden="true" />}
    </Tag>
  );
};
